import { ROUTES } from './paths'

export interface PageMeta {
  title: string
  subtitle: string
  /** Показывать ли переключатель периода в верхней панели. */
  showPeriod: boolean
}

export const PAGE_META: Record<string, PageMeta> = {
  [ROUTES.home]: {
    title: 'Главная',
    subtitle: 'Состояние площадки в реальном времени',
    // ТЗ п. 4.1: посетители, автомобили и события на главной считаются за выбранный период.
    showPeriod: true,
  },
  [ROUTES.clients]: {
    title: 'Поток посетителей',
    subtitle: 'Посетители АЗС и очереди на кассах',
    showPeriod: true,
  },
  [ROUTES.cars]: {
    title: 'Поток автомобилей',
    subtitle: 'Посещение и распознавание номеров автомобилей',
    showPeriod: true,
  },
  [ROUTES.events]: { title: 'События', subtitle: '', showPeriod: false },
}
